<template>
  <div
    :class="{'list-item--disabled': isDisabled}"
    class="list-item"
  >
    <button
      v-if="sortable"
      class="list-item__handle"
    >
      <font-awesome-icon icon="arrows-alt-v" />
    </button>
    <avatar
      v-if="avatarPresent"
      :name="avatarName"
      size="md"
      class="list-item__avatar"
    />
    <div class="list-item__content">
      <div class="list-item__title">
        <a
          v-if="titleClickable"
          class="list-item__link"
          @click.prevent="$emit('on-click')"
        >{{ title }}</a>
        <span v-else>{{ title }}</span>
      </div>
      <div class="list-item__subline">{{ subline }}</div>
    </div>
    <switch-input
      v-if="switchValue !== null"
      :name="inputName"
      :label-visible="false"
      :value="switchValue"
      class="list-item__switch"
      direction="vertical"
      @input="$emit('switch-input')"
    />

    <dropdown-input
      v-if="dropdownOptions !== null"
      :options="dropdownOptions"
      class="list-item__dropdown"
      theme="primary"
      position="right"
      @select="handleDropdownSelect"
    >
      <button>
        <span class="fa fa-ellipsis-h" />
      </button>
    </dropdown-input>
  </div>
</template>

<script>
import isBlank from 'is-blank'
import FormMixin from '@/mixins/forms/Form'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import Avatar from '@/components/ui/Avatar'

export default {
  mixins: [FormMixin],
  components: {
    FontAwesomeIcon,
    Avatar
  },
  props: {
    avatarName: {
      type: String,
      required: false,
      default: () => ''
    },
    title: {
      type: String,
      required: true
    },
    subline: {
      type: String,
      required: false,
      default: () => ''
    },
    titleClickable: {
      type: Boolean,
      default: () => false
    },
    sortable: {
      type: Boolean,
      default: () => false
    },
    switchName: {
      type: String,
      required: false,
      default: () => ''
    },
    switchValue: {
      type: Boolean,
      required: false,
      default: () => null
    },
    dropdownOptions: {
      type: Array,
      required: false,
      default: () => null
    }
  },
  data () {
    return {
      editable: false
    }
  },
  computed: {
    inputName () {
      return this.switchName === ''
        ? this.title
        : this.switchName
    },
    avatarPresent () {
      return !isBlank(this.avatarName)
    },
    isDisabled () {
      return this.switchValue !== null
        ? !this.switchValue
        : false
    },
    hasHref () {
      return isBlank(this.href)
    }
  },
  methods: {
    handleDropdownSelect ({ value }) {
      this.$emit('dropdown-select', value)
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.list-item
  display: flex
  flex-direction: row
  justify-content: flex-start
  align-items: center
  height: rem-calc(125)
  border-top: 1px solid #e1e5ea
  border-bottom: 1px solid #e1e5ea

  & + &
    border-top: 0

  &.sortable-chosen
    background: #f5f5f5

  &__handle
    min-width: rem-calc(50)
    height: rem-calc(40)
    border: 1px solid #333
    color: #333
    border-radius: 2px;
    margin-right: rem-calc(50)
    outline: none

  &--disabled &__handle
    border-color: #eee
    color: #9CABA8

  &__avatar
    margin-right: rem-calc(15)

  &__content
    flex: auto

  &__title
    @include font-size(22, 30)
    font-weight: 700
    margin-bottom: rem-calc(5)

  &__link
    color: #000
    cursor: pointer

  &--disabled &__title
    color: #9CABA8

  &__subline
    @include font-size(14, 18)
    color: #9CABA8

  &__dropdown
    position: relative;

    button
      +font-size(14, 42)
      color: $color-grey-3
      border: 1px solid $color-grey-1
      width: rem-calc(54)
      height: rem-calc(42)
      border-radius: 3px
      margin-left: rem-calc(16)

      &:focus
        color: $color-black
        border-color: $color-black
        outline: 0

</style>




// WEBPACK FOOTER //
// src/components/ui/ListItem.vue